"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabeledRatingStars = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LabeledRatingStarsMixin = require("../../mixins/components/LabeledRatingStarsMixin");
var StyledLabeledRatingStars = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledLabeledRatingStars",
  componentId: "c11n-8-107-0__sc-13tpwil-0"
})(["", ""], _LabeledRatingStarsMixin.LabeledRatingStarsMixin);
exports.StyledLabeledRatingStars = StyledLabeledRatingStars;